import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OneDialogConfirmationService } from '@one/angular-kit/modal';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import qnsbnurlAPI from  '../../services/qn-sbn-API-url'
import { CustomConfirmationDialogComponent } from '../../custom-confirmation-dialog/custom-confirmation-dialog.component';
@Component({
  selector: 'dl-edit-workflow',
  templateUrl: './edit-workflow.component.html',
  styleUrls: ['./edit-workflow.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditWorkflowComponent implements OnInit {
  public localNotificationId = 'SBN-CPS-2020-014_UK';
  public storedData;
  public DueDateEnabled: boolean = true;
  public feedbackEnabled: boolean = true;
  public nonSavedFeedback: boolean = false;
  public isValid: boolean = false;
  public fbDisabledAndEnabled: boolean = false;
  public feedbackAdded: boolean = false;
  public constructor(private _QnSbnDataService:QnSbnDataService,private qnsbnService: QnSbnService,private router: Router, private activatedRoute: ActivatedRoute, private readonly dialog?: MatDialog, private readonly oneSnackBar?: OneSnackBarService, private confirmationDialog?: OneDialogConfirmationService) {}
  @Output() public cancelBtnState = new EventEmitter<boolean>();
  public ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      // console.log('in bottom action:',storeData);
      this.storedData = storeData;
    })
   this.localNotificationId = this.qnsbnService.getLocalNotificationID();
    this._QnSbnDataService.DueDateEnabled$.subscribe(
      res =>{
        this.DueDateEnabled = res;
      } 
    )
    this._QnSbnDataService.FeedbackEnabled$.subscribe(
      res =>{
        this.feedbackEnabled = res;
      } 
    )
  }

  public cancelNotificationProcess(): void {
        this._QnSbnDataService.isAfoBtnDisabled$.subscribe(
          res =>{
            this.nonSavedFeedback = res;
        })
        this._QnSbnDataService.isValidFeedback$.subscribe(
          res =>{
            this.isValid = res;
        })
         this._QnSbnDataService.fbDisabledAndEnabled$.subscribe(
          res =>{
            this.fbDisabledAndEnabled = res;
          } 
        )
        this._QnSbnDataService.isFeedbackAdded$.subscribe(
          res =>{
            this.feedbackAdded = res;
          } 
        )
        if((this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) || 
          (this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded) ||
          (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) ||
          (!this.nonSavedFeedback && this.isValid && this.fbDisabledAndEnabled )){
          const nonSavedFeedbackDialogRef = this.dialog.open(CustomConfirmationDialogComponent, {
            data: {
              title: 'Warning',
              message: 'You have changes not applied in the feedback form controls. Please apply them to continue.',
              confirmButtonText: 'Accept'
            }
          });
          nonSavedFeedbackDialogRef.afterClosed().subscribe((confirmed: boolean) => {
            return
          })
          this._QnSbnDataService.isAfoBtnDisabled$.next(true);
          this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
        }else{
          const cancelDialogRef = this.confirmationDialog.open('Cancel notification', 'You have started creating a local notification. To keep the progress, choose the "Save Changes" button. To close without saving, choose the "Discard" button.', 'Save changes', 'Discard');

          cancelDialogRef.addPanelClass('rcp-delete-dialog');
          this.cancelBtnState.emit(true);
          cancelDialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.saveCloseNotification();
              // this.router.navigateByUrl('/notification');
            
            } else {
              this._QnSbnDataService.resetAll();
              this.router.navigateByUrl('/notification');
              this.oneSnackBar.open(`Progress in new local notification ${this.localNotificationId} discarded successfully`, OneSnackBarType.SUCCESS, '', { duration: 5000 });
            }
          });
        }
  }
  
  public async saveCloseNotification(): Promise<void> {
    await this._QnSbnDataService.setDDToggle(this.DueDateEnabled);
    await this._QnSbnDataService.setFBToggle(this.feedbackEnabled);
    let saveNCloseData;
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
    })
    if(!this._QnSbnDataService.isEmpty(this.storedData)){
      saveNCloseData = this._QnSbnDataService.saveNcloseData(this.storedData);
    } 
    let fileData = this._QnSbnDataService.fileUploadData(this.storedData); 
    sessionStorage.setItem('reloadOverview', 'true');     
    if(fileData.length> 0){
      for(let f=0;f<=(fileData.length-1);f++){
        if(fileData[f].uploadFile) {
          this.qnsbnService.dataToBeSaveOnS3(saveNCloseData,fileData[f],this.storedData['localNotificationId']['NotificationId'],(f==(fileData.length-1)) ? true :false, false);
        } else if(f==(fileData.length-1)){
          this.saveNCloseDraftApiCall(saveNCloseData);
        }
      }        
    } else {
      this.saveNCloseDraftApiCall(saveNCloseData);
    }
  }

  public async saveNCloseDraftApiCall(saveNCloseData):Promise<void> {
    await this._QnSbnDataService.setDDToggle(this.DueDateEnabled);
    await this._QnSbnDataService.setFBToggle(this.feedbackEnabled);
    this.qnsbnService.saveNCloseNotificationData(saveNCloseData).subscribe(res=>{
      this._QnSbnDataService.resetAll();
      this.router.navigateByUrl('/notification');
      this.oneSnackBar.open('Local notification saved successfully', OneSnackBarType.SUCCESS, '', { duration: 5000 });
    },(error: HttpErrorResponse) => {
      this.qnsbnService.httpErrorHandler(error, 'Local notification not saved successfully');
    });
  }
}
